<template>
  <div>
    <el-button v-if="isLoginFail" @click="loginAgain">重新登录</el-button>
    <div v-else>登录中，请稍后...</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Cookies from "js-cookie";
import { getExplore } from '@/assets/js/util'
import { deviceTypeMap } from "@/assets/js/commonMap.js";

const explore = getExplore()
export default {
  name: "casLogin",
  data() {
    return {
      isLoginFail: false,
      form: {
        deviceType: '',
        deviceVersion: '', // 操作系统版本 window11
        device: `${explore.name} ${explore.fullVersion}`, // 浏览器类型
      },
    };
  },
  computed: {
    ...mapGetters('common', ['osInfo']),
  },
  async created() {
    await this.getModernOSInfo()
    const { name, versionName } = this.osInfo
    this.form.deviceVersion = versionName
    this.form.deviceType = name
    this.init();
  },
  methods: {
    ...mapActions('common', ['getModernOSInfo']),
    // 解析cas重定向地址参数
    getParams() {
      // 提取 query string 中的 code
      const location = window.location
      const codeMatch = location.search.match(/[?&]code=([^&]*)/);
      const code = codeMatch ? decodeURIComponent(codeMatch[1].replace(/\+/g, ' ')) : null;
      
      // 提取 hash fragment 中的 query 参数
      const hashQueryMatch = location.hash.match(/[?&]query=([^&]*)/);
      const query = hashQueryMatch ? decodeURIComponent(hashQueryMatch[1].replace(/\+/g, ' ')) : null;
      return { code, query }
    },
    init() {
      const { code, query: queryUrl } = this.getParams()
      if (!code) {
        this.goCas(queryUrl);
      } else {
        this.getInfoToken(code, queryUrl);
      }
    },
    loginAgain() {
      const { query: queryUrl } = this.getParams()
      this.goCas(queryUrl);
    },
    goCas(queryUrl) {
      const origin = window.location.origin;
      const href = `${process.env.VUE_APP_CAS_URL}/cas/oauth2.0/authorize?response_type=code&client_id=${process.env.VUE_APP_CAS_CLIENT_ID}&redirect_uri=${encodeURIComponent(`${origin}/#/casLogin?query=${queryUrl ? encodeURIComponent(queryUrl) : ''}`)}`
      window.location.href = href;
    },
    getInfoToken(code, queryUrl) {
      this.$httpAuth
        .post("/v2/appUserService/casLogin", {
          code,
          ...this.loginParams()
        })
        .then(res => {
            const { token, refreshToken = '', profile, isAdmin, deviceId } = res?.data ?? {}
            Cookies.set("Dealer-User-Token", token);
            Cookies.set("Dealer-User-RefreshToken", refreshToken);
            this.$common.setDealer(profile);
            this.$common.setAdmin(isAdmin);
            this.$common.setLoginInfo(res.data);
            if (deviceId) localStorage.setItem("deviceId", deviceId)
            this.loadBaseInfo(queryUrl)
        }).catch(()=> { this.isLoginFail = false })
    },
    loadBaseInfo(queryUrl) {
      this.$httpAuth
        .post("/v2/appBaseService/info", { token: process.env.VUE_APP_INFO_TOKEN })
        .then(res => {
          this.$common.setBaseInfo(res.data);
          const newUrl = window.location.origin + window.location.pathname + window.location.hash;
          window.history.replaceState(null, '', newUrl);
          this.$router.push({
            path: queryUrl || "/dashboard/index"
          });
        }).catch(() => {
        });
    },
    loginParams() {
      const { device, deviceVersion, deviceType } = this.form
      let value = {
        device,
        deviceType: deviceTypeMap.get(deviceType) ?? 0, // deviceType：0 pc windows, 1 ANDROID 2: ios 3.小程序 4. 鸿蒙 5 pc mac
        deviceVersion,
      }
      return value
    },
  }
}
</script>